"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExtensionContext;
(function (ExtensionContext) {
    ExtensionContext["Desktop"] = "desktop";
    ExtensionContext["Server"] = "server";
    ExtensionContext["Unknown"] = "unknown";
    ExtensionContext["Cloud"] = "cloud";
    ExtensionContext["PublicWeb"] = "public-web";
    ExtensionContext["PublicDesktop"] = "public-desktop";
})(ExtensionContext = exports.ExtensionContext || (exports.ExtensionContext = {}));
var ExtensionMode;
(function (ExtensionMode) {
    ExtensionMode["Authoring"] = "authoring";
    ExtensionMode["Viewing"] = "viewing";
    ExtensionMode["Unknown"] = "unknown";
})(ExtensionMode = exports.ExtensionMode || (exports.ExtensionMode = {}));
var AnnotateEnum;
(function (AnnotateEnum) {
    AnnotateEnum["Mark"] = "mark";
    AnnotateEnum["Point"] = "point";
    AnnotateEnum["Area"] = "area";
})(AnnotateEnum = exports.AnnotateEnum || (exports.AnnotateEnum = {}));
var ColumnType;
(function (ColumnType) {
    ColumnType["Discrete"] = "discrete";
    ColumnType["Continuous"] = "continuous";
    ColumnType["Unknown"] = "unknown";
})(ColumnType = exports.ColumnType || (exports.ColumnType = {}));
var DashboardObjectType;
(function (DashboardObjectType) {
    DashboardObjectType["Blank"] = "blank";
    DashboardObjectType["Worksheet"] = "worksheet";
    DashboardObjectType["QuickFilter"] = "quick-filter";
    DashboardObjectType["ParameterControl"] = "parameter-control";
    DashboardObjectType["PageFilter"] = "page-filter";
    DashboardObjectType["Legend"] = "legend";
    DashboardObjectType["Title"] = "title";
    DashboardObjectType["Text"] = "text";
    DashboardObjectType["Image"] = "image";
    DashboardObjectType["WebPage"] = "web-page";
    DashboardObjectType["Extension"] = "extension";
})(DashboardObjectType = exports.DashboardObjectType || (exports.DashboardObjectType = {}));
var DataType;
(function (DataType) {
    DataType["String"] = "string";
    DataType["Int"] = "int";
    DataType["Float"] = "float";
    DataType["Bool"] = "bool";
    DataType["Date"] = "date";
    DataType["DateTime"] = "date-time";
    DataType["Spatial"] = "spatial";
    DataType["Unknown"] = "unknown";
})(DataType = exports.DataType || (exports.DataType = {}));
var DialogStyle;
(function (DialogStyle) {
    DialogStyle["Window"] = "window";
    DialogStyle["Modal"] = "modal";
    DialogStyle["Modeless"] = "modeless";
})(DialogStyle = exports.DialogStyle || (exports.DialogStyle = {}));
var EncodedDataType;
(function (EncodedDataType) {
    EncodedDataType["Number"] = "number";
    EncodedDataType["String"] = "string";
    EncodedDataType["Date"] = "date";
    EncodedDataType["Boolean"] = "boolean";
})(EncodedDataType = exports.EncodedDataType || (exports.EncodedDataType = {}));
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["INITIALIZATION_ERROR"] = "initialization-error";
    ErrorCodes["INTERNAL_ERROR"] = "internal-error";
    ErrorCodes["MISSING_ENUM_MAPPING"] = "missing-enum-mapping";
    ErrorCodes["MISSING_PARAMETER"] = "missing-parameter";
    ErrorCodes["PERMISSION_DENIED"] = "permission-denied";
    ErrorCodes["PRES_MODEL_PARSING_ERROR"] = "pres-model-parsing-error";
    ErrorCodes["VERSION_NOT_CONFIGURED"] = "version-not-configured";
    ErrorCodes["VISIBILITY_ERROR"] = "visibility-error";
    ErrorCodes["UNKNOWN_VERB_ID"] = "unknown-verb-id";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
var FieldAggregationType;
(function (FieldAggregationType) {
    FieldAggregationType["Sum"] = "sum";
    FieldAggregationType["Avg"] = "avg";
    FieldAggregationType["Min"] = "min";
    FieldAggregationType["Max"] = "max";
    FieldAggregationType["Stdev"] = "stdev";
    FieldAggregationType["Stdevp"] = "stdevp";
    FieldAggregationType["Var"] = "var";
    FieldAggregationType["Varp"] = "varp";
    FieldAggregationType["Collect"] = "collect";
    FieldAggregationType["Count"] = "count";
    FieldAggregationType["Countd"] = "countd";
    FieldAggregationType["Median"] = "median";
    FieldAggregationType["Attr"] = "attr";
    FieldAggregationType["None"] = "none";
    FieldAggregationType["Year"] = "year";
    FieldAggregationType["Qtr"] = "qtr";
    FieldAggregationType["Month"] = "month";
    FieldAggregationType["Day"] = "day";
    FieldAggregationType["Hour"] = "hour";
    FieldAggregationType["Minute"] = "minute";
    FieldAggregationType["Second"] = "second";
    FieldAggregationType["Week"] = "week";
    FieldAggregationType["Weekday"] = "weekday";
    FieldAggregationType["MonthYear"] = "month-year";
    FieldAggregationType["Mdy"] = "mdy";
    FieldAggregationType["End"] = "end";
    FieldAggregationType["TruncYear"] = "trunc-year";
    FieldAggregationType["TruncQtr"] = "trunc-qtr";
    FieldAggregationType["TruncMonth"] = "trunc-month";
    FieldAggregationType["TruncWeek"] = "trunc-week";
    FieldAggregationType["TruncDay"] = "trunc-day";
    FieldAggregationType["TruncHour"] = "trunc-hour";
    FieldAggregationType["TruncMinute"] = "trunc-minute";
    FieldAggregationType["TruncSecond"] = "trunc-second";
    FieldAggregationType["Quart1"] = "quart1";
    FieldAggregationType["Quart3"] = "quart3";
    FieldAggregationType["Skewness"] = "skewness";
    FieldAggregationType["Kurtosis"] = "kurtosis";
    FieldAggregationType["InOut"] = "in-out";
    FieldAggregationType["User"] = "user";
})(FieldAggregationType = exports.FieldAggregationType || (exports.FieldAggregationType = {}));
var FieldRoleType;
(function (FieldRoleType) {
    FieldRoleType["Dimension"] = "dimension";
    FieldRoleType["Measure"] = "measure";
    FieldRoleType["Unknown"] = "unknown";
})(FieldRoleType = exports.FieldRoleType || (exports.FieldRoleType = {}));
/**
 *  The different update types for applying filter.
 */
var FilterUpdateType;
(function (FilterUpdateType) {
    FilterUpdateType["Add"] = "add";
    FilterUpdateType["All"] = "all";
    FilterUpdateType["Replace"] = "replace";
    FilterUpdateType["Remove"] = "remove";
})(FilterUpdateType = exports.FilterUpdateType || (exports.FilterUpdateType = {}));
var SheetType;
(function (SheetType) {
    SheetType["Dashboard"] = "dashboard";
    SheetType["Story"] = "story";
    SheetType["Worksheet"] = "worksheet";
})(SheetType = exports.SheetType || (exports.SheetType = {}));
var DomainRestrictionType;
(function (DomainRestrictionType) {
    DomainRestrictionType["All"] = "all";
    DomainRestrictionType["List"] = "list";
    DomainRestrictionType["Range"] = "range";
})(DomainRestrictionType = exports.DomainRestrictionType || (exports.DomainRestrictionType = {}));
var DateStepPeriod;
(function (DateStepPeriod) {
    DateStepPeriod["Years"] = "years";
    DateStepPeriod["Quarters"] = "quarters";
    DateStepPeriod["Months"] = "months";
    DateStepPeriod["Weeks"] = "weeks";
    DateStepPeriod["Days"] = "days";
    DateStepPeriod["Hours"] = "hours";
    DateStepPeriod["Minutes"] = "minutes";
    DateStepPeriod["Seconds"] = "seconds";
})(DateStepPeriod = exports.DateStepPeriod || (exports.DateStepPeriod = {}));
/**
 * The option for specifying which values to include for filtering.
 */
var FilterNullOption;
(function (FilterNullOption) {
    FilterNullOption["NullValues"] = "nullvalues";
    FilterNullOption["NonNullValues"] = "nonnullvalues";
    FilterNullOption["AllValues"] = "allvalues";
})(FilterNullOption = exports.FilterNullOption || (exports.FilterNullOption = {}));
/**
 * The type of filter domain
 */
var FilterDomainType;
(function (FilterDomainType) {
    FilterDomainType["Relevant"] = "relevant";
    FilterDomainType["Database"] = "database";
})(FilterDomainType = exports.FilterDomainType || (exports.FilterDomainType = {}));
/**
 * Internal enum for specifying the selection type for select marks api.
 */
var SelectionUpdateType;
(function (SelectionUpdateType) {
    SelectionUpdateType["Replace"] = "select-replace";
    SelectionUpdateType["Add"] = "select-add";
    SelectionUpdateType["Remove"] = "select-remove";
})(SelectionUpdateType = exports.SelectionUpdateType || (exports.SelectionUpdateType = {}));
/**
 * Internal enum for specifying the select option for the select tuples api.
 */
var SelectOptions;
(function (SelectOptions) {
    SelectOptions["Simple"] = "select-options-simple";
    SelectOptions["Toggle"] = "select-options-toggle";
    SelectOptions["Menu"] = "select-options-menu";
    SelectOptions["Range"] = "select-options-range";
    SelectOptions["Search"] = "select-options-search";
})(SelectOptions = exports.SelectOptions || (exports.SelectOptions = {}));
/**
 * Internal enum for specifying the included values type for range selection.
 */
var QuantitativeIncludedValues;
(function (QuantitativeIncludedValues) {
    QuantitativeIncludedValues["IncludeNull"] = "include-null";
    QuantitativeIncludedValues["IncludeNonNull"] = "include-non-null";
    QuantitativeIncludedValues["IncludeAll"] = "include-all";
})(QuantitativeIncludedValues = exports.QuantitativeIncludedValues || (exports.QuantitativeIncludedValues = {}));
/**
 * Internal enum for specifying a hierarchical level selection state.
 */
var HierarchicalLevelSelectionState;
(function (HierarchicalLevelSelectionState) {
    HierarchicalLevelSelectionState["AllSelected"] = "all-selected";
    HierarchicalLevelSelectionState["NoneSelected"] = "none-selected";
    HierarchicalLevelSelectionState["SomeSelected"] = "some-selected";
    HierarchicalLevelSelectionState["UnknownSelected"] = "unknown-selected";
})(HierarchicalLevelSelectionState = exports.HierarchicalLevelSelectionState || (exports.HierarchicalLevelSelectionState = {}));
/**
 * Type of mark for a given marks card in a viz.
 */
var MarkType;
(function (MarkType) {
    MarkType["Bar"] = "bar";
    MarkType["Line"] = "line";
    MarkType["Area"] = "area";
    MarkType["Square"] = "square";
    MarkType["Circle"] = "circle";
    MarkType["Shape"] = "shape";
    MarkType["Text"] = "text";
    MarkType["Map"] = "map";
    MarkType["Pie"] = "pie";
    MarkType["GanttBar"] = "gantt-bar";
    MarkType["Polygon"] = "polygon";
    MarkType["Heatmap"] = "heatmap";
    MarkType["VizExtension"] = "viz-extension";
})(MarkType = exports.MarkType || (exports.MarkType = {}));
/**
 * Internal enum for specifying the type of filter
 */
var FilterType;
(function (FilterType) {
    FilterType["Categorical"] = "categorical";
    FilterType["Range"] = "range";
    FilterType["RelativeDate"] = "relativeDate";
    FilterType["Hierarchical"] = "hierarchical";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
/**
 * Internal enum for specifying the DateRangeType of a relative date filter
 */
var DateRangeType;
(function (DateRangeType) {
    /**
     * Refers to the last day, week, month, etc. of the date period.
     */
    DateRangeType["Last"] = "last";
    /**
     * Refers to the last N days, weeks, months, etc. of the date period.
     */
    DateRangeType["LastN"] = "lastN";
    /**
     * Refers to the next day, week, month, etc. of the date period.
     */
    DateRangeType["Next"] = "next";
    /**
     * Refers to the next N days, weeks, months, etc. of the date period.
     */
    DateRangeType["NextN"] = "nextN";
    /**
     * Refers to the current day, week, month, etc. of the date period.
     */
    DateRangeType["Current"] = "current";
    /**
     * Refers to everything up to and including the current day, week, month, etc. of the date period.
     */
    DateRangeType["ToDate"] = "toDate";
})(DateRangeType = exports.DateRangeType || (exports.DateRangeType = {}));
/**
 * Used to determine if the launching of an extension dialog succeeded or failed.
 */
var ExtensionDialogResult;
(function (ExtensionDialogResult) {
    ExtensionDialogResult["DialogAlreadyOpen"] = "dialog-already-open";
    ExtensionDialogResult["InvalidDomain"] = "invalid-domain";
    ExtensionDialogResult["Success"] = "success";
})(ExtensionDialogResult = exports.ExtensionDialogResult || (exports.ExtensionDialogResult = {}));
/**
 * Used to optimize the getSummaryData/getUnderlyingTableData results
 * Mapped from external IncludeDataValuesOption
 */
var ApiShowDataTableFormat;
(function (ApiShowDataTableFormat) {
    ApiShowDataTableFormat["NativeValuesOnly"] = "native-values-only";
    ApiShowDataTableFormat["FormattedValuesOnly"] = "formatted-values-only";
    ApiShowDataTableFormat["NativeAndFormattedValues"] = "native-and-formatted-values";
})(ApiShowDataTableFormat = exports.ApiShowDataTableFormat || (exports.ApiShowDataTableFormat = {}));
/**
 * Used to set page size for export layout options.
 */
var PageSizeOption;
(function (PageSizeOption) {
    PageSizeOption["Letter"] = "letter";
    PageSizeOption["Legal"] = "legal";
    PageSizeOption["Note"] = "note";
    PageSizeOption["Folio"] = "folio";
    PageSizeOption["Tabloid"] = "tabloid";
    PageSizeOption["Ledger"] = "ledger";
    PageSizeOption["Statement"] = "statement";
    PageSizeOption["Executive"] = "executive";
    PageSizeOption["A3"] = "a3";
    PageSizeOption["A4"] = "a4";
    PageSizeOption["A5"] = "a5";
    PageSizeOption["B4"] = "b4";
    PageSizeOption["B5"] = "b5";
    PageSizeOption["Quarto"] = "quarto";
    PageSizeOption["Unspecified"] = "unspecified";
})(PageSizeOption = exports.PageSizeOption || (exports.PageSizeOption = {}));
/**
 * Used to set the page orientation mode for export layout options.
 */
var PageOrientation;
(function (PageOrientation) {
    PageOrientation["Printer"] = "printer";
    PageOrientation["Portrait"] = "portrait";
    PageOrientation["Landscape"] = "landscape";
})(PageOrientation = exports.PageOrientation || (exports.PageOrientation = {}));
/**
 * Used to set scale mode for export layout options.
 */
var ScaleMode;
(function (ScaleMode) {
    ScaleMode["ScaleAuto"] = "auto";
    ScaleMode["ScalePercentage"] = "percent";
    ScaleMode["ScaleFitPages"] = "fit-pages";
})(ScaleMode = exports.ScaleMode || (exports.ScaleMode = {}));
/**
 * Used by setFitAndScaleValues to scale percent values
 */
var PageScalingOption;
(function (PageScalingOption) {
    PageScalingOption["ScalePctAuto"] = "auto";
    PageScalingOption["ScalePct400"] = "pct400";
    PageScalingOption["ScalePct200"] = "pct200";
    PageScalingOption["ScalePct100"] = "pct100";
    PageScalingOption["ScalePct90"] = "pct90";
    PageScalingOption["ScalePct80"] = "pct80";
    PageScalingOption["ScalePct75"] = "pct75";
    PageScalingOption["ScalePct60"] = "pct60";
    PageScalingOption["ScalePct50"] = "pct50";
    PageScalingOption["ScalePct25"] = "pct25";
})(PageScalingOption = exports.PageScalingOption || (exports.PageScalingOption = {}));
/**
 * Used by setFitAndScaleValues to scale fit page values
 */
var FitPages;
(function (FitPages) {
    FitPages["FitOneHigh"] = "fit0x1";
    FitPages["FitTwoHigh"] = "fit0x2";
    FitPages["FitOneWide"] = "fit1x0";
    FitPages["FitTwoWide"] = "fit2x0";
})(FitPages = exports.FitPages || (exports.FitPages = {}));
/**
 * Used by getVisualSpecificationAsync
 */
var EncodingType;
(function (EncodingType) {
    EncodingType["Color"] = "color";
    EncodingType["Size"] = "size";
    EncodingType["Label"] = "label";
    EncodingType["Detail"] = "detail";
    EncodingType["Tooltip"] = "tooltip";
    EncodingType["Shape"] = "shape";
    EncodingType["Path"] = "path";
    EncodingType["Angle"] = "angle";
    EncodingType["Geometry"] = "geometry";
    EncodingType["Custom"] = "custom";
})(EncodingType = exports.EncodingType || (exports.EncodingType = {}));
var PulseTimeDimension;
(function (PulseTimeDimension) {
    PulseTimeDimension["Today"] = "Today";
    PulseTimeDimension["Yesterday"] = "Yesterday";
    PulseTimeDimension["WeekToDate"] = "WeekToDate";
    PulseTimeDimension["LastWeek"] = "LastWeek";
    PulseTimeDimension["MonthToDate"] = "MonthToDate";
    PulseTimeDimension["LastMonth"] = "LastMonth";
    PulseTimeDimension["QuarterToDate"] = "QuarterToDate";
    PulseTimeDimension["LastQuarter"] = "LastQuarter";
    PulseTimeDimension["YearToDate"] = "YearToDate";
    PulseTimeDimension["LastYear"] = "LastYear";
})(PulseTimeDimension = exports.PulseTimeDimension || (exports.PulseTimeDimension = {}));
var PulseErrorMessageVisibility;
(function (PulseErrorMessageVisibility) {
    PulseErrorMessageVisibility["Visible"] = "visible";
    PulseErrorMessageVisibility["Hidden"] = "hidden";
    PulseErrorMessageVisibility["Suppressed"] = "suppressed";
})(PulseErrorMessageVisibility = exports.PulseErrorMessageVisibility || (exports.PulseErrorMessageVisibility = {}));
//# sourceMappingURL=Enums.js.map